import React, { useState, useEffect } from "react";
import * as api from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { COMPANY_TYPES, Field, SELECT_CLS } from "./constants";

const EMPTY = { name: "", type: "supplier", contact_name: "", phone: "", email: "", website: "", address: "", contract_number: "", notes: "" };

export function CompanyDialog({ company, open, onClose, onDone }) {
    const [form, setForm] = useState(EMPTY);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (open) setForm(company ? { ...EMPTY, ...Object.fromEntries(Object.keys(EMPTY).map((k) => [k, company[k] ?? ""])) } : EMPTY);
    }, [open, company]);

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async () => {
        if (!form.name.trim()) { toast.error("Nom requis"); return; }
        setSaving(true);
        try {
            if (company) await api.updatePrinterCompany(company.id, form);
            else await api.createPrinterCompany(form);
            toast.success(company ? "Entreprise mise à jour" : "Entreprise ajoutée");
            onDone?.();
            onClose();
        } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
        finally { setSaving(false); }
    };

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="max-w-lg">
                <DialogHeader><DialogTitle>{company ? "Modifier l'entreprise" : "Nouvelle entreprise / contact"}</DialogTitle></DialogHeader>
                <div className="grid grid-cols-2 gap-3 py-1" data-testid="company-form">
                    <Field label="Nom *"><Input value={form.name} onChange={set("name")} placeholder="ex : Office Supplies SA" data-testid="co-name" /></Field>
                    <Field label="Type">
                        <select value={form.type} onChange={set("type")} className={SELECT_CLS} data-testid="co-type">
                            {Object.entries(COMPANY_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                        </select>
                    </Field>
                    <Field label="Personne de contact"><Input value={form.contact_name} onChange={set("contact_name")} data-testid="co-contact" /></Field>
                    <Field label="Téléphone"><Input value={form.phone} onChange={set("phone")} placeholder="+41 22 ..." data-testid="co-phone" /></Field>
                    <Field label="Email"><Input type="email" value={form.email} onChange={set("email")} data-testid="co-email" /></Field>
                    <Field label="Site web"><Input value={form.website} onChange={set("website")} placeholder="https://" data-testid="co-website" /></Field>
                    <Field label="N° contrat / client"><Input value={form.contract_number} onChange={set("contract_number")} className="font-mono" data-testid="co-contract" /></Field>
                    <Field label="Adresse"><Input value={form.address} onChange={set("address")} data-testid="co-address" /></Field>
                    <Field label="Notes" className="col-span-2">
                        <textarea value={form.notes} onChange={set("notes")} rows={2} className="w-full px-2 py-1.5 text-sm border rounded-md" placeholder="Horaires, délais de livraison, conditions du contrat..." data-testid="co-notes" />
                    </Field>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>Annuler</Button>
                    <Button onClick={submit} disabled={saving} data-testid="co-submit">{saving ? "..." : company ? "Enregistrer" : "Ajouter"}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
